export default function ForWhoSection() {
  const idealFor = [
    {
      text: 'quer falar melhor em reuniões',
      icon: 'ri-presentation-line',
      gradient: 'from-blue-500 to-blue-600'
    },
    {
      text: 'quer melhorar sua comunicação profissional',
      icon: 'ri-briefcase-4-line',
      gradient: 'from-purple-500 to-purple-600'
    },
    {
      text: 'deseja desenvolver liderança',
      icon: 'ri-trophy-line',
      gradient: 'from-amber-500 to-amber-600'
    },
    {
      text: 'quer perder o medo de falar em público',
      icon: 'ri-shield-check-line',
      gradient: 'from-green-500 to-green-600'
    },
    {
      text: 'sente que tem potencial mas trava ao se expressar',
      icon: 'ri-key-2-line',
      gradient: 'from-red-500 to-red-600'
    }
  ];

  const profiles = [
    { icon: 'ri-briefcase-line', label: 'Empresário', color: 'blue' },
    { icon: 'ri-line-chart-line', label: 'Vendedor', color: 'green' },
    { icon: 'ri-user-star-line', label: 'Profissional Liberal', color: 'purple' },
    { icon: 'ri-graduation-cap-line', label: 'Estudante', color: 'amber' },
    { icon: 'ri-team-line', label: 'Líder de Equipe', color: 'red' }
  ];

  return (
    <section className="py-16 bg-gradient-to-br from-white via-gray-50 to-white relative overflow-hidden">
      {/* Elementos decorativos de fundo */}
      <div className="absolute top-0 right-0 w-96 h-96 bg-[#F19E1A]/5 rounded-full blur-3xl"></div>
      <div className="absolute bottom-0 left-0 w-96 h-96 bg-[#F19E1A]/5 rounded-full blur-3xl"></div>
      
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        {/* Header moderno */}
        <div className="text-center mb-12">
          <div className="inline-block mb-4">
            <span className="text-sm font-semibold text-gray-500 uppercase tracking-wider">Público-Alvo</span>
          </div>
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-3">
            Para quem é o <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#F19E1A] to-[#e08d0f]">VoxDay</span>?
          </h2>
          <p className="text-lg text-gray-600">
            Esse evento é ideal para quem:
          </p>
        </div>

        {/* Cards com gradientes e ícones */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-12 max-w-4xl mx-auto">
          {idealFor.map((item, index) => (
            <div 
              key={index}
              className="group relative bg-white rounded-2xl p-6 shadow-md hover:shadow-xl transition-all duration-300 border border-gray-100 hover:border-[#F19E1A]/30 overflow-hidden"
            >
              {/* Gradiente de fundo no hover */}
              <div className="absolute inset-0 bg-gradient-to-br from-[#F19E1A]/0 to-[#F19E1A]/5 opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
              
              <div className="relative flex items-start gap-4">
                <div className="flex-shrink-0">
                  <div className={`w-12 h-12 bg-gradient-to-br ${item.gradient} rounded-xl flex items-center justify-center shadow-lg group-hover:scale-110 transition-transform duration-300`}>
                    <i className={`${item.icon} text-white text-xl`}></i>
                  </div>
                </div>
                <div className="flex-1">
                  <p className="text-base font-medium text-gray-800 group-hover:text-gray-900">
                    {item.text}
                  </p>
                </div>
                <div className="opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  <i className="ri-arrow-right-up-line text-[#F19E1A] text-xl"></i>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Divisor elegante */}
        <div className="flex items-center justify-center mb-10">
          <div className="h-px bg-gradient-to-r from-transparent via-gray-300 to-transparent w-full max-w-md"></div>
          <span className="px-4 text-sm font-semibold text-gray-500 whitespace-nowrap">Não importa se você é</span>
          <div className="h-px bg-gradient-to-r from-transparent via-gray-300 to-transparent w-full max-w-md"></div>
        </div>

        {/* Cards de perfis modernos */}
        <div className="grid grid-cols-2 md:grid-cols-5 gap-4 mb-12">
          {profiles.map((profile, index) => (
            <div 
              key={index}
              className="group relative bg-white rounded-2xl p-6 shadow-md hover:shadow-xl transition-all duration-300 hover:-translate-y-2 text-center border border-gray-100 overflow-hidden"
            >
              {/* Efeito de brilho no hover */}
              <div className="absolute inset-0 bg-gradient-to-br from-white to-gray-50 opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
              
              <div className="relative">
                <div className="mb-3 inline-block">
                  <div className="w-14 h-14 bg-gradient-to-br from-[#F19E1A] to-[#e08d0f] rounded-2xl flex items-center justify-center shadow-lg group-hover:scale-110 group-hover:rotate-6 transition-all duration-300">
                    <i className={`${profile.icon} text-white text-2xl`}></i>
                  </div>
                </div>
                <p className="text-sm font-bold text-gray-800">
                  {profile.label}
                </p>
              </div>
            </div>
          ))}
        </div>

        {/* CTA final com design premium */}
        <div className="relative">
          <div className="absolute inset-0 bg-gradient-to-r from-[#F19E1A]/20 via-[#e08d0f]/20 to-[#F19E1A]/20 blur-2xl"></div>
          <div className="relative bg-gradient-to-r from-[#F19E1A] to-[#e08d0f] rounded-3xl p-8 text-center shadow-2xl">
            <div className="flex items-center justify-center gap-3 mb-3">
              <i className="ri-global-line text-white text-3xl"></i>
              <p className="text-2xl md:text-3xl font-bold text-white">
                A comunicação impacta
              </p>
            </div>
            <p className="text-xl md:text-2xl font-bold text-white">
              <span className="underline decoration-2 underline-offset-4">todas as áreas</span> da sua vida.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
